/* eslint-disable valid-typeof */
import { Calendar } from "@amir04lm26/react-modern-calendar-date-picker";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getGuestReports, getGuestSlice } from "services/getApi";
import { covertToDateValue } from "utils/helper";
import moment from "moment-jalaali";
import { useMemo } from "react";
import Client from "../../hooks/useAxios"
import * as XLSX from 'xlsx';

function ReportsPrint() {
    const redirect = useNavigate();
    const [reports, setReport] = React.useState();
    const [len, setLen] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [is30, setIs30] = React.useState("close");
    const [print, setPrint] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [selectedDayRange, setSelectedDayRange] = React.useState(null);


    function handleOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }

    useEffect(() => {
        setLoading(true)
        getGuestReports().then(res => {
            setLoading(false)
            // setReport(res.data)
        }).catch((err) => {
            if (err.response.status === 401) {
                redirect("/auth/login")
            }
        })

        window.addEventListener("afterprint", () => {
            setPrint(false)
        })
    }, [])

    function handlePrint() {
        setPrint(true)
        setTimeout(() => {
            window.print();
        }, 600);
    }

    useMemo(() => {


    }, [selectedDayRange])


    function handleXsel() {

        // Acquire Data (reference to the HTML table)
        let table_elt = document.getElementById("table-report");

        // Extract Data (create a workbook object from the table)
        let workbook = XLSX.utils.table_to_book(table_elt);

        // Process Data 
        let res = 0
        Object.values(document.getElementsByClassName(".pr")).map(i => {
            let num = parseInt(i.textContent.split(",").join(""))
            res = res + num
        })

        let ws = workbook.Sheets["Sheet1"];
        XLSX.utils.sheet_add_aoa(ws, [["جمع کل: " + res.toString() + "ریال"]], { origin: -1 });

        // Package and Release Data (`writeFile` tries to write and save an XLSB file)
        XLSX.writeFile(workbook, "گزارش مهمانسرا.xlsb");
    }

    function handleSubmit() {
        if (selectedDayRange && len) {
            let time = new Date(moment(selectedDayRange && covertToDateValue(selectedDayRange), 'jYYYY/jM/jD').format('YYYY/M/D'))
            console.log('====================================');
            console.log(time);
            console.log('====================================');
            Client().post("/guest/get-report30", { today: time, length: len }).then(res => {
                setReport(res.data.data);
                setTimeout(() => {
                    setIs30(true)
                }, 500);
            })
        } else {
            alert("فیلد هارو تکمیل کنید")
        }
    }


    return (
        <>
            <div className={`flex flex-col w-full p-5 text-[11px] ${is30 === "close" ? "justify-center" : "justify-start"} items-center h-screen`}>
                <div onClick={handleClose} className={`fixed w-full h-[100vh] left-0 top-0 bg-[#0001] z-[100] backdrop-blur-sm ${!open ? "hidden" : "block"}`}></div>
                {
                    loading ?
                        <div className="loading2">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div> :
                        <div className={`page-ani flex flex-col items-center justify-center flex-wrap h-auto  bg-base-300 rounded-box p-2 w-full`}>
                            <div>
                                {
                                    print ? null :
                                        is30 === "close" ?
                                            <>
                                                {
                                                    !open ? null :
                                                        <Calendar
                                                            value={selectedDayRange}
                                                            onChange={setSelectedDayRange}
                                                            shouldHighlightWeekends
                                                            locale="fa"
                                                        />
                                                }
                                                <h1>تاریخ مبدا:</h1>
                                                <input
                                                    defaultValue={selectedDayRange && covertToDateValue(selectedDayRange)}
                                                    onFocus={handleOpen}
                                                    type="text"
                                                    name="logout_date"
                                                    placeholder="تاریخ مبدا را وارد کنید!"
                                                    class="input input-bordered w-full mx-2 my-2"
                                                />
                                                <input
                                                    defaultValue={selectedDayRange && covertToDateValue(selectedDayRange)}
                                                    onChange={(e) => setLen(e.target.value)}
                                                    type="number"
                                                    name="length"
                                                    placeholder="تعداد روز گزارش"
                                                    class="input input-bordered w-full mx-2 my-2"
                                                />
                                            </>
                                            :
                                            null
                                }
                                {
                                    print ? null :
                                        is30 === "close" ?
                                            <button className="btn btn-accent mx-2" onClick={() => redirect("/")}>بازگشت به داشبورد</button>
                                            :
                                            <button className="btn btn-accent mx-2" onClick={() => setIs30("close")}>بازگشت</button>
                                }
                                {
                                    print ? null :
                                        is30 === "close" ?
                                            <>
                                                {
                                                    len &&
                                                    <button className="btn btn-primary mx-2" onClick={handleSubmit}>گزارش {len} روزه</button>
                                                }
                                            </>
                                            :

                                            <>
                                                <button className="btn btn-warning mx-2" onClick={handlePrint}>چاپ</button>
                                                <button className="btn btn-secondary mx-2" onClick={handleXsel}>خروجی اکسل</button>
                                            </>

                                }
                            </div>
                            {
                                is30 === "close" ? null :
                                    <div className="overflow-x-auto mt-5 w-full">
                                        <div className="text-center p-5 text-[20px]"><p>گزارش {is30 === true ? "ماهانه" : "هفتگی"} اقامتی مهمانسرا دانشگاه شمال</p></div>
                                        <table className="table table-compact w-full text-center ">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>نام و نام خانوادگی</th>
                                                    <th>شهر</th>
                                                    <th>تاریخ ورود</th>
                                                    <th>تاریخ خروج</th>
                                                    <th>شماره اتاق</th>
                                                    <th>هزینه اقامت</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    reports.map((item, i) => (
                                                        <tr>
                                                            <th>{i + 1}</th>
                                                            <td>{item.fullname}</td>
                                                            <td>{item.city}</td>
                                                            <td>{item.login_date}</td>
                                                            <td>{item.logout_date}</td>
                                                            <td>{item.number_room}</td>
                                                            <td>{item.price?.toLocaleString()} تومان</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>#</th>
                                                    <th>نام و نام خانوادگی</th>
                                                    <th>شهر</th>
                                                    <th>تاریخ ورود</th>
                                                    <th>تاریخ خروج</th>
                                                    <th>شماره اتاق</th>
                                                    <th>هزینه اقامت</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        <table id="table-report" className="table hidden table-compact w-full text-center ">
                                            <thead>
                                                <tr>
                                                    <th>نام و نام خانوادگی</th>
                                                    <th>شهر</th>
                                                    <th>تاریخ ورود</th>
                                                    <th>تاریخ خروج</th>
                                                    <th>شماره اتاق</th>
                                                    <th>هزینه اقامت</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    reports.map((item, i) => (
                                                        <tr>
                                                            <td className="w-[300px]">{item.fullname}</td>
                                                            <td>{item.city}</td>
                                                            <td>{item.login_date}</td>
                                                            <td>{item.logout_date}</td>
                                                            <td>{item.number_room}</td>
                                                            <td className=".pr">{parseInt(item.price + "0")?.toLocaleString()}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>نام و نام خانوادگی</th>
                                                    <th>شهر</th>
                                                    <th>تاریخ ورود</th>
                                                    <th>تاریخ خروج</th>
                                                    <th>شماره اتاق</th>
                                                    <th>ریال</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                            }
                        </div>
                }
            </div>
        </>
    );
}

export default ReportsPrint;